<script>
  import { Accordion } from "paxray-components-svelte";
  import SideKPI from "lib/components/sideKPI.svelte";
  import { TextInput } from "carbon-components-svelte";
  import ApplicationSelection from "./ApplicationSelection.svelte";
  export let selectedRows = [];
  export let selectedRowIds = [];
  export let rows = [];
  export let detailView = false;
  export let loading = false;
  let costPerHour = 75;
  let timeInWeeks = 4;
  let totalWorkers = 12;
  let totalSensors = 4;
  let listOfUniqueApplications = [];

  /// KPIs

  $: listOfUniqueApplications = Array.from(
    new Set(rows.map((row) => row.applications).flat())
  );

  function updateSelectedRows() {
    selectedRows = rows.filter((row) =>
      selectedRowIds.includes(String(row.id))
    );
  }

  $: {
    if (selectedRowIds.length > 0) {
      updateSelectedRows();
    }
  }
  $: totalTimeSum = selectedRows.reduce((sum, row) => sum + row.totaltime, 0);
  $: totalCount = selectedRows.reduce((sum, row) => sum + row.ncases, 0);
  $: totalCost = Math.ceil(
    (totalTimeSum / 3600 / timeInWeeks) *
      (52 / timeInWeeks) *
      (totalWorkers / totalSensors) *
      costPerHour
  ).toLocaleString();
  $: convertedTime = convertTime(totalTimeSum);

  function convertTime(totalSeconds) {
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    let result = "";
    if (days > 0) {
      result += days + "d" + ", ";
    }
    if (hours > 0) {
      result += hours + "h" + ", ";
    }
    if (minutes > 0 || (days === 0 && hours === 0)) {
      result += minutes + "m";
    }
    return result;
  }
</script>

<Accordion heading="Information" open={true}>
  <div class="kpi_wrapper">  
    <SideKPI
      name="Total Time"
      showIcon={true}
      icon="time_dark"
      value={loading? "..." : convertedTime}
    />
    <SideKPI
      name="Total Count"
      showIcon={true}
      icon="hash"
      value={loading? "...":totalCount}
    />
    <SideKPI
      name="Potential Savings"
      showIcon={true}
      icon="cash"
      value={loading? "..." : totalCost}
      unit={loading? "" : "$"}
    />
  </div>
</Accordion>
<Accordion heading="Applications" open={true}>
  <ApplicationSelection bind:rows {detailView} {selectedRows} {loading}/>
</Accordion>
<Accordion heading="Calculation">
  <div class="kpi_wrapper">
    <TextInput
      labelText="Cost / hour"
      placeholder={costPerHour}
      bind:value={costPerHour}
    />
    <TextInput
      labelText="Recording Time"
      placeholder={timeInWeeks}
      bind:value={timeInWeeks}
    />
    <TextInput
      labelText="Used Sensors"
      placeholder={totalSensors}
      bind:value={totalSensors}
    />
    <TextInput
      labelText="Total Employees"
      placeholder={totalWorkers}
      bind:value={totalWorkers}
    />
  </div>
</Accordion>

<style>
  .kpi_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
</style>
